<template>
  <q-page>
    <div class="q-pa-md q-gutter-sm">
      <Breadcrumbs path-name="collar" path-method="productCollarReturnDetail" />
      <div class="row q-gutter-sm">
        <div class="col">
          <q-input filled v-model="collarDetail.created_at" readonly="" label="領出日期" />
        </div>
        <div class="col">
          <q-input filled v-model="collarDetail.User.nick_name" readonly="" label="領出人" />
        </div>
        <div class="col">
          <q-input filled v-model="collarStatus[collarDetail.status]" readonly="" label="領用單狀態" />
        </div>
        <div class="col col-12">
          <q-input filled v-model="collarDetail.note" label="備註" />
        </div>
      </div>
      <div class="row">
        <div class="col">
          <q-table
            title="領出需要歸還的項目"
            :data="collarDetail.CollarDetail"
            :columns="columns"
            row-key="name"
            :pagination.sync="tabelSet"
          >
            <template v-slot:body="props">
              <q-tr :props="props">
                <q-td v-if="false" key="action" :props="props">
                  <q-btn
                    v-show="props.row.status === 0"
                    color="info"
                    label="歸還"
                    @click="props.row.status = 2, handleStatusChange(props.row)"
                  />
                  <q-btn
                    v-show="props.row.status === 0 && false"
                    color="blue"
                    label="銷帳"
                    style="margin-left: 5px;"
                    @click="props.row.status = 1, handleStatusChange(props.row)"
                  />
                </q-td>
                <q-td key="image" :props="props">
                  <ProductImage :image-src="props.row.Product.image"/>
                </q-td>
                <q-td key="status" :props="props">{{ collarStatus[props.row.status] }}</q-td>
                <q-td key="category" :props="props">{{ props.row.Group.title }}</q-td>
                <q-td key="title" :props="props">
                  {{ (props.row.Product && props.row.Product.title)?props.row.Product.title :"" }}
                </q-td>
                <q-td key="nickName" :props="props">
                  {{ (props.row.Product && props.row.Product.nick_name)?props.row.Product.nick_name : ""}}
                </q-td>
                <q-td key="stock" :props="props">{{ props.row.quantity }}</q-td>
                <q-td key="used" :props="props">
                  <q-input filled v-if="handleReturnCheck(props.row)" v-model="props.row.used" @input="handleReturnInput(props.row)" />
                  {{ (props.row.Record && props.row.Record.ID !== 0)? props.row.Record.Used : "" }}
                </q-td>
                <q-td key="return" :props="props">
                  <q-input filled v-if="handleReturnCheck(props.row)" v-model="props.row.return" />
                  {{ (props.row.Record && props.row.Record.ID !== 0)? props.row.Record.Return : "" }}
                </q-td>
              </q-tr>
            </template>
          </q-table>
        </div> 
      </div>
    </div>
    <q-page-sticky position="top-right" :offset="[18, 18]">
      <router-link :to="'/collar/return'">
        <q-btn
          color="blue"
          icon="undo"
          label="返回領用歸回列表"
        />
      </router-link>
      <q-btn 
        v-if="loginUser.permission && loginUser.permission.Collar > 2 && (collarDetail.status === 0 || collarDetail.status === 1)" 
        color="green" 
        icon="save" 
        label="儲存" 
        class="q-ml-sm"
        @click="collarLocalReturnData"
      />
    </q-page-sticky>
  </q-page>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import Breadcrumbs from '@/components/Breadcrumbs'
  import ProductImage from '@/components/ProductImage'

  export default {
    name: "ReturnDetail",
    components: { Breadcrumbs, ProductImage },
    data() {
      return {
        isEdit: false,
        splitterModel: 20,
        tab: 1,
        products: [],
        search: {
          status: '',
          hasStock: 1,
          category: '',
          supplier: '',
        },
        columns: [
          // { name: 'action', label: '操作', align: 'center' },
          { name: 'image', label: '圖片', align: 'center' },
          { name: 'status', align: 'center', label: '狀態', field: 'status'},
          { name: 'category', label: '領用群組', align: 'center',},
          { name: 'title', align: 'center', label: '產品名稱', field: 'title' },
          { name: 'nickName', label: '物料暱稱', field: 'nick_name', align: 'center',},
          { name: 'stock', label: '領用數', align: 'center',},
          { name: 'used', label: '實際使用數', align: 'center' },
          { name: 'return', label: '歸還數', align: 'center' },
        ],
        tabelSet: {
          sortBy: 'desc',
          descending: false,
          page: 1,
          rowsPerPage: 10
        }
      }
    },
    computed: {
      ...mapGetters(['collarDetail', 'collarStatus', 'loginUser'])
    },
    created() {
      // this.$store.dispatch('CategoryGetListWithProduct')
      this.$store.dispatch('collarGetDetail', this.$route.params.id)
        .then(res => {
          if (!res.Answer) {
            this.$router.push({ path: '/product/collar-return' })
          }
        })
    },
    methods: {
      handleSaveClick() {
        if (this.isEdit) {
          this.update()
        }else {
          this.store()
        }
        
      },
      handleStatusChange(row) {
        this.$store.dispatch("collarDetailUpdateStatus", row)
          .then(res => {
            if (res.Count === 0) {
              this.$router.go('/product/collar-return')
            }
          })
      },
      handleDelete(prod) {
        this.$q.dialog({
          dark: true,
          title: '確認！',
          message: '是否確定要刪除此項目？',
          cancel: true,
          persistent: true
        }).onOk(() => {
          this.$store.dispatch("collarGroupProductDelete", prod).then(res => {
            this.$router.go(this.$route.fullPath)
          })
        })
      },
      handleReturnInput(row) {
        row.return = Number.parseInt(row.quantity) - Number.parseInt(row.used)
      },
      handleReturnCheck(row){
        if (row.Group && row.Group.group_product) {
          let gp = row.Group.group_product.find(s => s.product_id === row.ProductID)
          return (row.status === 0 && Number.parseInt(gp.is_need_return) === 1)
        }

      },
      countStockTotal(stockBlock) {
        let count = 0
        stockBlock.map(row => {
         count += parseInt(row.Stock)
        })
        return count
      },
      ...mapActions(['collarDetailUpdateStatus', 'collarLocalReturnData'])
    }
  }
</script>
